import React from 'react';
import './style.css';

export default function SearchInput({onChange, onClick, ref, id, placeholder, type}) {

    function search(event){
        if(onChange != null){
            onChange(event.target.value);
        }
    }

    return (
        <div className='search-input' id={id} onClick={onClick} >
            <input className='search' type={type != null ? type : "text"} placeholder={placeholder != null ? placeholder : "Búsqueda"} onChange={search}  ref={ref}></input>
        </div>
    )
}